var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38279 15.9241C8.49805 15.8764 8.60621 15.8063 8.70055 15.7136C8.70303 15.7112 8.70549 15.7087 8.70794 15.7063L15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289C15.3166 6.90237 14.6834 6.90237 14.2929 7.29289L9 12.5858L9 1C9 0.447715 8.55229 3.25552e-07 8 3.49693e-07C7.44772 3.73835e-07 7 0.447715 7 1L7 12.5858L1.70711 7.29289C1.31658 6.90237 0.683418 6.90237 0.292894 7.29289C-0.0976309 7.68342 -0.0976308 8.31658 0.292894 8.70711L7.29289 15.7071C7.48581 15.9 7.73793 15.9976 7.99077 16M8.38279 15.9241C8.26756 15.9719 8.14146 15.9988 8.00923 16L8.38279 15.9241Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardArrow);
export default __webpack_public_path__ + "static/media/downward-arrow.9786738b0cda44edc500dbb37e06f204.svg";
export { ForwardRef as ReactComponent };